module.exports = __webpack_public_path__ + "img/info-bg.8ea0602b.png";